import { render, staticRenderFns } from "./AuthInVendor.vue?vue&type=template&id=6f94f94f&scoped=true&"
import script from "./AuthInVendor.vue?vue&type=script&lang=js&"
export * from "./AuthInVendor.vue?vue&type=script&lang=js&"
import style0 from "./AuthInVendor.vue?vue&type=style&index=0&id=6f94f94f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94f94f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f94f94f')) {
      api.createRecord('6f94f94f', component.options)
    } else {
      api.reload('6f94f94f', component.options)
    }
    module.hot.accept("./AuthInVendor.vue?vue&type=template&id=6f94f94f&scoped=true&", function () {
      api.rerender('6f94f94f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/AuthInVendor.vue"
export default component.exports